'use client'

import { useAuth } from '@/dc-shared-web/src'
import { useEnvContext } from 'next-runtime-env'
import Script from 'next/script'

const FSScript = () => {
  const { NEXT_PUBLIC_FULLSTORY_ENABLED, NEXT_PUBLIC_FULLSTORY_ORG_ID } =
    useEnvContext()

  const { user } = useAuth()

  if (NEXT_PUBLIC_FULLSTORY_ENABLED !== 'true') {
    return null
  }

  const currentTeam = user?.teams?.find(
    (team) => team.name === user?._currOfficeName
  )

  return (
    <Script id='dc-full-story'>
      {`
        window['_fs_host'] = 'fullstory.com';
        window['_fs_script'] = 'edge.fullstory.com/s/fs.js';
        window['_fs_org'] = '${NEXT_PUBLIC_FULLSTORY_ORG_ID}';
        window['_fs_namespace'] = 'FS';
        (function(m,n,e,t,l,o,g,y){
            if (e in m) {if(m.console && m.console.log) { m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');} return;}
            g=m[e]=function(a,b,s){g.q?g.q.push([a,b,s]):g._api(a,b,s);};g.q=[];
            o=n.createElement(t);o.async=1;o.crossOrigin='anonymous';o.src='https://'+_fs_script;
            y=n.getElementsByTagName(t)[0];y.parentNode.insertBefore(o,y);
            g.identify=function(i,v,s){g(l,{uid:i},s);if(v)g(l,v,s)};g.setUserVars=function(v,s){g(l,v,s)};g.event=function(i,v,s){g('event',{n:i,p:v},s)};
            g.anonymize=function(){g.identify(!!0)};
            g.shutdown=function(){g("rec",!1)};g.restart=function(){g("rec",!0)};
            g.log = function(a,b){g("log",[a,b])};
            g.consent=function(a){g("consent",!arguments.length||a)};
            g.identifyAccount=function(i,v){o='account';v=v||{};v.acctId=i;g(o,v)};
            g.clearUserCookie=function(){};
            g.setVars=function(n, p){g('setVars',[n,p]);};
            g._w={};y='XMLHttpRequest';g._w[y]=m[y];y='fetch';g._w[y]=m[y];
            if(m[y])m[y]=function(){return g._w[y].apply(this,arguments)};
            g._v="1.3.0";
        })(window,document,window['_fs_namespace'],'script','user');

        FS('setIdentity', {
          uid: '${user.uuid}',
          properties: {
              user_uuid: '${user.uuid}',
              email: '${user.email}',                    
              displayName: \`${user.name}\`,
              team: \`${user._currOfficeName}\`,
              team_uuid: '${currentTeam?.id || null}',
              customer_id: '${currentTeam?.customer_id || null}',
              internal: ${currentTeam?.is_internal || false},
              partner: ${currentTeam?.is_partner || false},
              trial: ${currentTeam?.is_trial || false},
              entitlement_crunch_assist: ${currentTeam?.entitlements.crunch_assist || false},
              entitlement_word: ${currentTeam?.entitlements.word_access || false},
              entitlement_sso: ${currentTeam?.entitlements.use_sso || false},
              entitlement_procore: ${currentTeam?.entitlements.procore_access || false},
              entitlement_cheat_sheet: ${currentTeam?.entitlements.cheat_sheet_access || false},
              entitlement_high_security: ${currentTeam?.entitlements.high_security || false},
              entitlement_project_features: ${currentTeam?.entitlements.project_features || false},
              entitlement_project_editor: ${currentTeam?.entitlements.project_editor || false},
          }
      });
    `}
    </Script>
  )
}

export default FSScript
